import { onError } from 'apollo-link-error';
import { captureMessageInSentry } from 'lib/captureInSentry';
import { Observable, Operation } from 'apollo-boost';
import { GraphQLError, DefinitionNode, OperationDefinitionNode } from 'graphql';
import redirectToRelationship from './redirectToRelationship';

export const errorLink = onError(({ graphQLErrors, forward, operation }) => {
  graphQLErrors?.forEach((graphQLError) => {
    captureGraphQLError(operation, graphQLError);
  });

  const context = operation.getContext();

  if (includesUnauthenticatedError(graphQLErrors) && !context.skipUnauthenticatedRedirection) {
    redirectToRelationship();

    return new Observable(() => {});
  }

  if (includesDownstreamServerError(graphQLErrors)) {
    return forward(operation);
  }
});

function captureGraphQLError(operation: Operation, graphQLError: GraphQLError) {
  captureMessageInSentry(`${getOperationType(operation)} ${operation.operationName} failed: ${graphQLError.message}`, graphQLError);
}

function includesUnauthenticatedError(graphQLErrors: readonly GraphQLError[] | undefined): graphQLErrors is GraphQLError[] {
  return graphQLErrors?.some((graphQLError) => graphQLError.extensions?.code === 'UNAUTHENTICATED') ?? false;
}

function includesDownstreamServerError(graphQLErrors: readonly GraphQLError[] | undefined): graphQLErrors is GraphQLError[] {
  return graphQLErrors?.some((graphQLError) => graphQLError.extensions?.code === 'INTERNAL_SERVER_ERROR') ?? false;
}

function isOperationDefinitionNode(node: DefinitionNode): node is OperationDefinitionNode {
  return node.kind === 'OperationDefinition';
}

function getOperationType(operation: Operation) {
  return operation.query.definitions.find(isOperationDefinitionNode)?.operation;
}
